import {
  Individual,
  EditAltOutline as EditAlt,
  InviteOutline as Invite,
} from '@aslanpay/portal-common-lib';
import { Button, Flex, Stack, Text, useDisclosure } from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import EditIndividualModal from '../../Individuals/EditIndividualModal/EditIndividualModal';
import InviteIndividualModal from '../../Individuals/InviteIndividualModal';

interface EmployeeProfileHeaderProps {
  employee: Individual;
  onInvalidateQuery: () => void;
}

function EmployeeProfileHeader({ employee, onInvalidateQuery }: EmployeeProfileHeaderProps) {
  const { isOpen: isInviteOpen, onOpen: onOpenInvite, onClose: onCloseInvite } = useDisclosure();
  const { isOpen: isEditOpen, onOpen: onOpenEdit, onClose: onCloseEdit } = useDisclosure();
  const location = useLocation();
  const navigate = useNavigate();
  const [wasOpenedViaNavigation, setWasOpenedViaNavigation] = useState(false);

  useEffect(() => {
    const state = location.state as { editDetails?: boolean } | null;
    if (state?.editDetails) {
      setWasOpenedViaNavigation(true);
      onOpenEdit();
      window.history.replaceState({}, '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEditSubmit = () => {
    onInvalidateQuery();
    if (wasOpenedViaNavigation) {
      navigate(-1);
    }
  };

  const renderModals = () => {
    return (
      <>
        <InviteIndividualModal
          selectedIndividuals={[employee.id]}
          isOpen={isInviteOpen}
          onClose={onCloseInvite}
          onInvite={onInvalidateQuery}
        />
        <EditIndividualModal
          employee={employee}
          isOpen={isEditOpen}
          onClose={onCloseEdit}
          onSubmit={handleEditSubmit}
        />
      </>
    );
  };

  return (
    <>
      {renderModals()}
      <Flex gap="20px" align="flex-start" justify="space-between">
        <Stack spacing="10px">
          <Text as="h2" textStyle="h2" color="brand.darkPurple" wordBreak="break-word">
            {`${employee.firstName} ${employee.lastName}`}
          </Text>
          <Text
            color="brand.black"
            textStyle="smallRegular"
          >{`Aslan ID: ${employee.friendlyId}`}</Text>
        </Stack>

        <Flex gap="10px">
          <Button
            width="auto"
            size="sm"
            variant="outline"
            leftIcon={<EditAlt boxSize="20px" />}
            onClick={onOpenEdit}
          >
            Edit details
          </Button>
          <Button
            width="auto"
            size="sm"
            leftIcon={<Invite boxSize="20px" />}
            onClick={onOpenInvite}
            isDisabled={employee.status !== 'CREATED' && employee.status !== 'INVITED'}
          >
            {employee.status === 'INVITED' ? 'Invite again' : 'Invite'}
          </Button>
        </Flex>
      </Flex>
    </>
  );
}

export default EmployeeProfileHeader;
